import Layout from '../../components/base/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Seguranca() {
  const { t } = useTranslation();
  
  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {t('safety_title')}
          </h1>
          <p className="text-xl text-gray-600">
            {t('safety_subtitle')}
          </p>
        </div>

        <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-8 h-8 flex items-center justify-center bg-red-100 rounded-lg">
              <i className="ri-alert-line text-2xl text-red-600"></i>
            </div>
            <h2 className="text-2xl font-semibold text-red-800">{t('safety_title')}</h2>
          </div>
          <p className="text-red-700 text-lg">
            {t('safety_description')}
          </p>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-2xl font-semibold mb-6">{t('safety_description')}</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-6">
              {[
                { principle: t('safety_rule1'), icon: "ri-shut-down-line", color: "red" },
                { principle: t('safety_rule2'), icon: "ri-flashlight-line", color: "yellow" },
                { principle: t('safety_rule3'), icon: "ri-shield-user-line", color: "blue" },
                { principle: t('safety_rule4'), icon: "ri-lock-line", color: "green" },
                { principle: t('safety_rule5'), icon: "ri-alert-line", color: "orange" },
                { principle: t('safety_rule6'), icon: "ri-eye-line", color: "purple" }
              ].map((item, index) => (
                <div key={index} className={`bg-${item.color}-50 p-6 rounded-lg border-l-4 border-${item.color}-500`}>
                  <div className="flex items-start space-x-4">
                    <div className={`w-12 h-12 flex items-center justify-center bg-${item.color}-100 rounded-lg`}>
                      <i className={`${item.icon} text-2xl text-${item.color}-600`}></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-2">{item.principle}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/59b79ecb999b96b52c78e561dc4504b9.jpg"
                alt={t('safety_title')}
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <Link 
            to="/engenheiro"
            className="flex items-center text-blue-600 hover:text-blue-700 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-arrow-left-line"></i>
            </div>
            {t('nav_engineer')}
          </Link>
          <Link 
            to="/quiz1"
            className="flex items-center bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('nav_quiz1')}
            <div className="w-5 h-5 flex items-center justify-center ml-2">
              <i className="ri-question-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  );
}
